import { render, staticRenderFns } from "./RelatoriosCRI.vue?vue&type=template&id=0cbd574e"
import script from "./RelatoriosCRI.vue?vue&type=script&lang=js"
export * from "./RelatoriosCRI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports